export const LOCATIONS = [
  {
    slug: 'downtown-dc',
    name: 'Downtown DC',
    title: 'Cannabis Dispensary in Downtown Washington, DC | Majestic Greens DMV',
    meta: 'Majestic Greens DMV is a cannabis dispensary in Downtown Washington, DC at 425 7th St NW — near Gallery Place, Capital One Arena and CityCenterDC. Online ordering, pickup or delivery. Adults 21+.',
    h1: 'Cannabis Dispensary in Downtown Washington, DC',
    intro: [
      'Majestic Greens DMV sits in the middle of Downtown Washington, DC at 425 7th St NW — steps from the Gallery Place–Chinatown Metro station, Capital One Arena, the National Portrait Gallery, and the shops at CityCenterDC. If you live, work, or stay downtown, we are the closest full-menu cannabis store to you.',
      'The menu covers exotic flower, pre-rolls, vape cartridges and disposables, edibles, concentrates, and shake — all listed live with current pricing. Order online, upload your ID at checkout, and choose quick pickup at the shop or delivery anywhere in the District.',
      'Getting here is easy: take the Red, Green, or Yellow line to Gallery Place–Chinatown and walk about two blocks, or order delivery and skip the trip entirely. We are open daily from 10:00 AM to 11:00 PM.',
    ],
    landmarks: 'Capital One Arena, the National Portrait Gallery, and CityCenterDC',
    faq: [
      { q: 'Is there a cannabis dispensary in Downtown Washington, DC?', a: 'Yes. Majestic Greens DMV is located at 425 7th St NW, Washington, DC 20004 — in the heart of Downtown, serving adults 21+ with pickup and delivery.' },
      { q: 'How do I get to Majestic Greens DMV by Metro?', a: 'Take the Red, Green, or Yellow line to Gallery Place–Chinatown. The shop at 425 7th St NW is about a two-block walk from the station.' },
      { q: 'What are your hours in Downtown DC?', a: 'We are open daily from 10:00 AM to 11:00 PM.' },
      { q: 'Do you deliver within Downtown DC?', a: 'Yes — delivery is available across Downtown and the entire District with a $40 minimum order.' },
    ],
  },
  {
    slug: 'penn-quarter',
    name: 'Penn Quarter',
    title: 'Cannabis near Penn Quarter, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis flower, vapes, edibles and concentrates with pickup or delivery near Penn Quarter, Washington DC. $40 minimum. Adults 21+.',
    h1: 'Cannabis near Penn Quarter, Washington DC',
    intro: [
      'Penn Quarter is the cultural heart of downtown DC — home to the Capital One Arena, the National Portrait Gallery, and some of the best dining in the District. Majestic Greens DMV is located right here at 425 7th St NW, making us the closest premium cannabis retailer for anyone living, working, or staying in Penn Quarter.',
      'Browse our full menu of exotic flower, pre-rolls, THC cartridges, edibles, and concentrates online, choose pickup or delivery at checkout, and upload your ID for quick verification. Every order over $40 qualifies, and our team confirms before fulfillment.',
    ],
    landmarks: 'Capital One Arena, the National Portrait Gallery, and the Gallery Place corridor',
    faq: [
      { q: 'Is there a cannabis store in Penn Quarter DC?', a: 'Yes. Majestic Greens DMV is located at 425 7th St NW, in the heart of Penn Quarter, serving adults 21+ with pickup and delivery.' },
      { q: 'What is the minimum order?', a: 'Our minimum order is $40 for both pickup and delivery orders.' },
      { q: 'How does ordering work?', a: 'Browse the menu, add products to your cart, choose pickup or delivery, upload your ID, and check out. Our team verifies and fulfills your order.' },
    ],
  },
  {
    slug: 'chinatown',
    name: 'Chinatown',
    title: 'Cannabis near Chinatown, Washington DC | Majestic Greens DMV',
    meta: 'Order premium cannabis online near Chinatown DC — flower, pre-rolls, vapes and edibles from Majestic Greens DMV, steps from the Friendship Arch. Adults 21+.',
    h1: 'Cannabis near Chinatown, Washington DC',
    intro: [
      'DC\'s Chinatown — centered on the Friendship Archway at 7th and H Streets NW — sits directly adjacent to our shop. Majestic Greens DMV at 425 7th St NW is quite literally around the corner, making pickup the fastest option in the neighborhood and delivery just as easy.',
      'Our menu covers everything from exotic top-shelf flower to discreet vape cartridges, edibles, pre-rolls, and concentrates. Order online, upload your ID, meet the $40 minimum, and our team verifies and fulfills your order quickly.',
    ],
    landmarks: 'the Friendship Archway, Gallery Place, and the 7th Street corridor',
    faq: [
      { q: 'How close is Majestic Greens DMV to Chinatown?', a: 'We are located at 425 7th St NW — just steps from the Friendship Archway and the heart of Chinatown.' },
      { q: 'Do I need to be 21 to order?', a: 'Yes. All customers must be 21 years of age or older, and ID verification is part of checkout.' },
      { q: 'Can I pick up my order?', a: 'Yes — choose pickup at checkout and collect your order at 425 7th St NW after verification.' },
    ],
  },
  {
    slug: 'capitol-hill',
    name: 'Capitol Hill',
    title: 'Cannabis near Capitol Hill, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis online ordering for Capitol Hill DC — exotic flower, vapes, edibles and concentrates with delivery. $40 minimum order. Adults 21+.',
    h1: 'Cannabis near Capitol Hill, Washington DC',
    intro: [
      'From Eastern Market to Lincoln Park, Capitol Hill is one of DC\'s most iconic neighborhoods — and Majestic Greens DMV delivers across it. Our downtown shop at 425 7th St NW is a short trip from the Hill, and our online menu makes ordering effortless no matter where you are in the neighborhood.',
      'Hill residents can browse indica, sativa, and hybrid flower, THC cartridges, edibles, pre-rolls, and concentrates, then choose delivery or pickup at checkout. Orders over $40 are verified with a quick ID upload and fulfilled by our local team.',
    ],
    landmarks: 'Eastern Market, the U.S. Capitol, and Barracks Row',
    faq: [
      { q: 'Do you deliver to Capitol Hill?', a: 'Yes — Capitol Hill is within our Washington DC delivery area. Enter your ZIP on our service area checker to confirm instantly.' },
      { q: 'What products are available?', a: 'Our live menu includes exotic flower, pre-rolls, vape cartridges, disposables, edibles, concentrates, and accessories.' },
      { q: 'Is there a minimum order for Capitol Hill?', a: 'The minimum order is $40, the same across all of Washington DC.' },
    ],
  },
  {
    slug: 'navy-yard',
    name: 'Navy Yard',
    title: 'Cannabis near Navy Yard, Washington DC | Majestic Greens DMV',
    meta: 'Order cannabis online near Navy Yard DC — premium flower, vapes and edibles from Majestic Greens DMV. Serving Nationals Park and The Yards. Adults 21+.',
    h1: 'Cannabis near Navy Yard, Washington DC',
    intro: [
      'Navy Yard has transformed into one of DC\'s most vibrant waterfront neighborhoods — home to Nationals Park, The Yards Park, and a booming residential scene. Majestic Greens DMV serves Navy Yard with a full premium cannabis menu and fast delivery.',
      'Skip the trip across town: browse the menu, build your cart over the $40 minimum, upload your ID, check out, and our team verifies your order before delivery.',
    ],
    landmarks: 'Nationals Park, The Yards Park, and the Anacostia Riverwalk',
    faq: [
      { q: 'Does Majestic Greens DMV deliver to Navy Yard?', a: 'Yes, Navy Yard is within our DC delivery area. Use the service area checker with your ZIP to confirm your exact address.' },
      { q: 'How fast is ordering?', a: 'Most customers complete checkout in under two minutes. Verification and fulfillment follow right after.' },
      { q: 'What do I need to order?', a: 'You must be 21 or older with a valid ID to upload at checkout, and your order must meet the $40 minimum.' },
    ],
  },
  {
    slug: 'georgetown',
    name: 'Georgetown',
    title: 'Cannabis near Georgetown, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis online ordering for Georgetown DC — exotic flower, cartridges, edibles and concentrates from Majestic Greens DMV. Adults 21+.',
    h1: 'Cannabis near Georgetown, Washington DC',
    intro: [
      'Georgetown\'s historic streets — from M Street to the C&O Canal — deserve a cannabis experience that matches the neighborhood\'s standards. Majestic Greens DMV brings a premium, curated menu to Georgetown residents through simple online ordering with delivery.',
      'Our catalog features exotic top-shelf flower, discreet vape cartridges, edibles, pre-rolls, and concentrates. Place your order online, upload your ID, meet the $40 minimum, and our team verifies every order before fulfillment.',
    ],
    landmarks: 'M Street, the Georgetown Waterfront, and the C&O Canal',
    faq: [
      { q: 'Can I order cannabis delivery in Georgetown?', a: 'Yes. Georgetown is within our Washington DC delivery area — order online and our team handles verification and fulfillment.' },
      { q: 'What is the delivery minimum?', a: 'The minimum order is $40 across all DC neighborhoods we serve.' },
      { q: 'What brands and products do you carry?', a: 'Our live menu updates directly from our store catalog — flower, vapes, edibles, concentrates, pre-rolls, and more.' },
    ],
  },
  {
    slug: 'dupont-circle',
    name: 'Dupont Circle',
    title: 'Cannabis near Dupont Circle, Washington DC | Majestic Greens DMV',
    meta: 'Order premium cannabis near Dupont Circle DC — flower, pre-rolls, vapes and edibles from Majestic Greens DMV. $40 minimum. Adults 21+.',
    h1: 'Cannabis near Dupont Circle, Washington DC',
    intro: [
      'Dupont Circle is one of DC\'s most energetic neighborhoods — embassy row architecture, the famous fountain, and a nightlife scene that never slows down. Majestic Greens DMV serves Dupont Circle with premium cannabis and a streamlined online ordering experience.',
      'Browse indica, sativa, and hybrid strains, THC cartridges, edibles, and concentrates from your phone, choose pickup or delivery, and check out in minutes. Every order is verified with a quick ID upload and meets a $40 minimum.',
    ],
    landmarks: 'Dupont Circle fountain, Embassy Row, and Connecticut Avenue',
    faq: [
      { q: 'Do you serve Dupont Circle?', a: 'Yes — Dupont Circle is squarely within our DC service area. Confirm your address instantly with our ZIP checker.' },
      { q: 'How do I place an order?', a: 'Shop the online menu, add items to your cart, choose pickup or delivery, upload your ID, and check out.' },
      { q: 'Is the menu the same as in-store?', a: 'Yes. Our online menu pulls live from our store catalog, so availability and pricing are always current.' },
    ],
  },
  {
    slug: 'adams-morgan',
    name: 'Adams Morgan',
    title: 'Cannabis near Adams Morgan, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis online ordering for Adams Morgan DC — exotic flower, vapes, edibles and concentrates. Serving 18th Street and beyond. Adults 21+.',
    h1: 'Cannabis near Adams Morgan, Washington DC',
    intro: [
      'Adams Morgan\'s legendary 18th Street corridor is all about character — and your cannabis should be too. Majestic Greens DMV serves Adams Morgan with a curated menu of exotic flower, pre-rolls, vape cartridges, edibles, and concentrates, all available through fast online ordering with delivery.',
      'No complicated process: build your cart over the $40 minimum, upload your ID, check out, and our team verifies before delivering anywhere in the neighborhood.',
    ],
    landmarks: '18th Street NW, Kalorama Park, and Columbia Road',
    faq: [
      { q: 'Is Adams Morgan in your delivery area?', a: 'Yes, Adams Morgan is within our Washington DC delivery area. Use the ZIP checker to confirm your exact address in seconds.' },
      { q: 'What is the minimum order amount?', a: '$40 — the same minimum applies across all of DC.' },
      { q: 'Can I see what is in stock before ordering?', a: 'Yes, our online menu is live and reflects the current store catalog.' },
    ],
  },
  {
    slug: 'columbia-heights',
    name: 'Columbia Heights',
    title: 'Cannabis near Columbia Heights, Washington DC | Majestic Greens DMV',
    meta: 'Order cannabis online near Columbia Heights DC — premium flower, cartridges, edibles and pre-rolls from Majestic Greens DMV. $40 minimum. Adults 21+.',
    h1: 'Cannabis near Columbia Heights, Washington DC',
    intro: [
      'From the DC USA corridor to Meridian Hill Park, Columbia Heights is one of the District\'s most dynamic communities. Majestic Greens DMV proudly delivers to Columbia Heights with a full premium cannabis menu and effortless online ordering.',
      'Choose from exotic and classic flower, THC cartridges and disposables, edibles, concentrates, and pre-rolls. Orders over $40 are verified with a quick ID upload and delivered by our local DC team.',
    ],
    landmarks: 'Meridian Hill Park, DC USA, and the 14th Street corridor',
    faq: [
      { q: 'Do you deliver to Columbia Heights?', a: 'Yes — Columbia Heights is within our DC delivery area. Enter your ZIP in the service area checker to confirm instantly.' },
      { q: 'What happens after I check out?', a: 'Our team verifies your ID and order details, then fulfills your order. The whole process is quick and straightforward.' },
      { q: 'Who can order?', a: 'Adults 21 and older with valid ID, ordering within our service area with a $40 minimum.' },
    ],
  },
  {
    slug: 'shaw',
    name: 'Shaw',
    title: 'Cannabis near Shaw, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis online ordering for Shaw DC — exotic flower, vapes, edibles and concentrates near U Street and Howard Theatre. Adults 21+.',
    h1: 'Cannabis near Shaw, Washington DC',
    intro: [
      'Shaw — home to the historic U Street corridor, the Howard Theatre, and some of DC\'s best food and music — is fully within the Majestic Greens DMV delivery area. We bring premium cannabis to Shaw through a fast, simple online ordering experience.',
      'Our live menu spans exotic top-shelf flower, pre-rolls, vape cartridges, disposables, edibles, and concentrates. Meet the $40 minimum, upload your ID, check out, and our team verifies your order before delivery.',
    ],
    landmarks: 'the U Street corridor, Howard Theatre, and Blagden Alley',
    faq: [
      { q: 'Does Majestic Greens DMV deliver to Shaw?', a: 'Yes, Shaw is within our Washington DC delivery area — confirm your address with our ZIP checker.' },
      { q: 'How long does ordering take?', a: 'Checkout takes about two minutes. Verification and fulfillment follow shortly after.' },
      { q: 'What products can I order in Shaw?', a: 'The full live menu: flower, pre-rolls, vapes, edibles, concentrates, disposables, and accessories.' },
    ],
  },
  {
    slug: 'logan-circle',
    name: 'Logan Circle',
    title: 'Cannabis near Logan Circle, Washington DC | Majestic Greens DMV',
    meta: 'Order premium cannabis near Logan Circle DC — flower, vapes, edibles and concentrates from Majestic Greens DMV. Delivery across 14th Street. Adults 21+.',
    h1: 'Cannabis near Logan Circle, Washington DC',
    intro: [
      'Logan Circle\'s Victorian rowhouses and the buzzing 14th Street corridor make it one of DC\'s most livable neighborhoods. Majestic Greens DMV delivers premium cannabis throughout Logan Circle with simple online ordering.',
      'Shop exotic flower, pre-rolls, cartridges, edibles, and concentrates, upload your ID at checkout, and meet the $40 minimum — our team verifies and delivers.',
    ],
    landmarks: 'Logan Circle park, 14th Street, and Studio Theatre',
    faq: [
      { q: 'Do you deliver to Logan Circle?', a: 'Yes — Logan Circle is within our DC delivery area. Confirm your address instantly with the ZIP checker.' },
      { q: 'What is the minimum order?', a: '$40 across all of Washington DC.' },
      { q: 'Is ID required?', a: 'Yes, a valid ID upload is part of checkout for all customers 21+.' },
    ],
  },
  {
    slug: 'u-street',
    name: 'U Street Corridor',
    title: 'Cannabis near U Street, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis delivery near U Street Corridor DC — exotic flower, vapes and edibles from Majestic Greens DMV. $40 minimum. Adults 21+.',
    h1: 'Cannabis near the U Street Corridor, Washington DC',
    intro: [
      'The U Street Corridor — from the 9:30 Club to Ben\'s Chili Bowl — is the beating heart of DC culture. Majestic Greens DMV serves the entire corridor with a premium live menu and fast delivery.',
      'Order flower, vapes, edibles, and concentrates online, upload your ID, and check out over the $40 minimum. Verification is quick and fulfillment is local.',
    ],
    landmarks: "the 9:30 Club, Ben's Chili Bowl, and the African American Civil War Memorial",
    faq: [
      { q: 'Is U Street in your delivery area?', a: 'Yes — the entire U Street Corridor is within our Washington DC delivery area.' },
      { q: 'How do I verify my age?', a: 'Upload a valid ID during checkout. Our team verifies every order before fulfillment.' },
      { q: 'What is the minimum order?', a: '$40 for all orders.' },
    ],
  },
  {
    slug: 'noma',
    name: 'NoMa',
    title: 'Cannabis near NoMa, Washington DC | Majestic Greens DMV',
    meta: 'Order cannabis online near NoMa DC — premium flower, cartridges, edibles and concentrates from Majestic Greens DMV. Delivery available. Adults 21+.',
    h1: 'Cannabis near NoMa, Washington DC',
    intro: [
      'NoMa\'s rapid growth — anchored by Union Market and the Metropolitan Branch Trail — has made it one of DC\'s most exciting neighborhoods. Majestic Greens DMV delivers premium cannabis across NoMa with easy online ordering.',
      'Browse the live menu, build a cart over $40, upload your ID, and choose delivery at checkout. Our local team verifies and fulfills every order.',
    ],
    landmarks: 'Union Market, NoMa-Gallaudet Metro, and the Metropolitan Branch Trail',
    faq: [
      { q: 'Do you deliver to NoMa?', a: 'Yes, NoMa is within our DC delivery area. Use the ZIP checker to confirm your address.' },
      { q: 'What products are available?', a: 'Exotic flower, pre-rolls, vapes, edibles, concentrates, and accessories — all live from our store catalog.' },
      { q: 'Is there a minimum?', a: '$40 minimum order.' },
    ],
  },
  {
    slug: 'union-market',
    name: 'Union Market',
    title: 'Cannabis near Union Market, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis near Union Market DC — flower, vapes, edibles and concentrates from Majestic Greens DMV. $40 minimum order. Adults 21+.',
    h1: 'Cannabis near Union Market, Washington DC',
    intro: [
      'Union Market and La Cosecha have turned this corner of NoMa into DC\'s food hall destination. Majestic Greens DMV serves the Union Market district with a premium cannabis menu and fast delivery.',
      'Order online in minutes: live menu, $40 minimum, ID upload at checkout, and quick verification before delivery.',
    ],
    landmarks: 'Union Market, La Cosecha, and the NoMa food hall district',
    faq: [
      { q: 'Does Majestic Greens DMV serve Union Market?', a: 'Yes — the Union Market district is within our Washington DC delivery area.' },
      { q: 'How does checkout work?', a: 'Add products to your cart, choose pickup or delivery, upload your ID, and place your order.' },
      { q: 'What is the minimum order?', a: '$40.' },
    ],
  },
  {
    slug: 'brookland',
    name: 'Brookland',
    title: 'Cannabis near Brookland, Washington DC | Majestic Greens DMV',
    meta: 'Order cannabis online near Brookland DC — premium flower, vapes, edibles and concentrates from Majestic Greens DMV. Delivery available. Adults 21+.',
    h1: 'Cannabis near Brookland, Washington DC',
    intro: [
      'Brookland\'s arts corridor and tree-lined streets — home to the Brookland Arts Walk and Catholic University — are fully within the Majestic Greens DMV delivery area.',
      'Shop premium flower, cartridges, edibles, and concentrates online with a $40 minimum. Upload your ID at checkout and our team handles verification and delivery.',
    ],
    landmarks: 'the Brookland Arts Walk, Catholic University, and 12th Street NE',
    faq: [
      { q: 'Do you deliver to Brookland?', a: 'Yes — Brookland is within our DC delivery area. Confirm your address with the ZIP checker.' },
      { q: 'What do I need to order?', a: 'Be 21+, have a valid ID to upload, and meet the $40 minimum.' },
      { q: 'Is the menu current?', a: 'Yes — our menu is live from the store catalog.' },
    ],
  },
  {
    slug: 'petworth',
    name: 'Petworth',
    title: 'Cannabis near Petworth, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis delivery near Petworth DC — exotic flower, pre-rolls, vapes and edibles from Majestic Greens DMV. $40 minimum. Adults 21+.',
    h1: 'Cannabis near Petworth, Washington DC',
    intro: [
      'Petworth\'s Georgia Avenue corridor and tight-knit community make it one of DC\'s most authentic neighborhoods. Majestic Greens DMV delivers premium cannabis throughout Petworth.',
      'Browse the live menu, build your cart over the $40 minimum, upload your ID, and check out — verification and delivery follow quickly.',
    ],
    landmarks: 'Georgia Avenue, the Petworth Library, and Grant Circle',
    faq: [
      { q: 'Is Petworth in your delivery area?', a: 'Yes — Petworth is within our Washington DC delivery area.' },
      { q: 'How long does verification take?', a: 'Our team verifies ID and order details quickly after checkout.' },
      { q: 'What is the minimum order?', a: '$40.' },
    ],
  },
  {
    slug: 'foggy-bottom',
    name: 'Foggy Bottom',
    title: 'Cannabis near Foggy Bottom, Washington DC | Majestic Greens DMV',
    meta: 'Order cannabis online near Foggy Bottom DC — premium flower, vapes, edibles and concentrates from Majestic Greens DMV. Adults 21+.',
    h1: 'Cannabis near Foggy Bottom, Washington DC',
    intro: [
      'Foggy Bottom — home to the Kennedy Center, the GWU campus, and the Watergate — is fully covered by Majestic Greens DMV delivery. Premium cannabis, ordered online in minutes.',
      'Choose from exotic flower, pre-rolls, vapes, edibles, and concentrates. Upload your ID, meet the $40 minimum, and our team verifies and delivers.',
    ],
    landmarks: 'the Kennedy Center, the GWU campus, and the Watergate',
    faq: [
      { q: 'Do you deliver to Foggy Bottom?', a: 'Yes — Foggy Bottom is within our DC delivery area.' },
      { q: 'Who can order?', a: 'Adults 21+ with a valid ID upload at checkout.' },
      { q: 'What is the minimum?', a: '$40 minimum order.' },
    ],
  },
  {
    slug: 'the-wharf',
    name: 'The Wharf',
    title: 'Cannabis near The Wharf, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis near The Wharf DC — flower, vapes, edibles and concentrates from Majestic Greens DMV. Delivery to the Southwest Waterfront. Adults 21+.',
    h1: 'Cannabis near The Wharf, Washington DC',
    intro: [
      'The Wharf\'s waterfront dining, The Anthem, and the historic Maine Avenue Fish Market have made Southwest DC a destination. Majestic Greens DMV delivers premium cannabis across The Wharf and Southwest Waterfront.',
      'Order online: live menu, $40 minimum, ID upload at checkout, and quick verification before delivery.',
    ],
    landmarks: 'The Anthem, the Southwest Waterfront, and the Maine Avenue Fish Market',
    faq: [
      { q: 'Do you deliver to The Wharf?', a: 'Yes — The Wharf and Southwest Waterfront are within our DC delivery area.' },
      { q: 'How do I order?', a: 'Shop the menu, choose pickup or delivery, upload your ID, and check out.' },
      { q: 'What is the minimum order?', a: '$40.' },
    ],
  },
  {
    slug: 'h-street',
    name: 'H Street Corridor',
    title: 'Cannabis near H Street Corridor, Washington DC | Majestic Greens DMV',
    meta: 'Order cannabis online near H Street Corridor DC — exotic flower, vapes, edibles and concentrates from Majestic Greens DMV. $40 minimum. Adults 21+.',
    h1: 'Cannabis near the H Street Corridor, Washington DC',
    intro: [
      'The H Street Corridor — from the Atlas Performing Arts Center to the streetcar line — is one of DC\'s most creative neighborhoods. Majestic Greens DMV delivers premium cannabis across H Street NE.',
      'Browse exotic flower, vapes, edibles, and concentrates online, upload your ID, and check out over the $40 minimum. Verification and delivery follow.',
    ],
    landmarks: 'the Atlas Performing Arts Center, the H Street streetcar, and Union Station',
    faq: [
      { q: 'Is H Street in your delivery area?', a: 'Yes — the H Street Corridor is within our Washington DC delivery area.' },
      { q: 'What is the minimum order?', a: '$40.' },
      { q: 'Is ID verification required?', a: 'Yes — a valid ID upload is part of every checkout.' },
    ],
  },
  {
    slug: 'tenleytown',
    name: 'Tenleytown',
    title: 'Cannabis near Tenleytown, Washington DC | Majestic Greens DMV',
    meta: 'Premium cannabis delivery near Tenleytown DC — flower, vapes, edibles and concentrates from Majestic Greens DMV. Serving American University area. Adults 21+.',
    h1: 'Cannabis near Tenleytown, Washington DC',
    intro: [
      'Tenleytown — anchored by Tenley Circle, American University, and the Wisconsin Avenue retail corridor — is fully within the Majestic Greens DMV delivery area.',
      'Order premium flower, pre-rolls, cartridges, edibles, and concentrates online with a $40 minimum. Upload your ID at checkout and our team verifies and delivers.',
    ],
    landmarks: 'Tenley Circle, American University, and Wisconsin Avenue',
    faq: [
      { q: 'Do you deliver to Tenleytown?', a: 'Yes — Tenleytown is within our DC delivery area. Confirm with the ZIP checker.' },
      { q: 'Who can order?', a: 'Adults 21+ with valid ID.' },
      { q: 'What is the minimum?', a: '$40 minimum order.' },
    ],
  },
];

export const HUB_PAGES = [
  {
    slug: 'cannabis-washington-dc',
    name: 'Washington, DC',
    title: 'Cannabis in Washington, DC | Premium Menu & Online Ordering — Majestic Greens DMV',
    meta: 'Majestic Greens DMV — premium cannabis in Washington, DC. Exotic flower, pre-rolls, vapes, edibles and concentrates with pickup or delivery. 425 7th St NW. Adults 21+.',
    h1: 'Cannabis in Washington, DC',
    intro: [
      'Majestic Greens DMV is a premium cannabis retailer located at 425 7th St NW in downtown Washington, DC. Since 2018, we have served the District with a carefully curated menu of exotic flower, pre-rolls, THC cartridges, edibles, concentrates, and accessories — backed by genuine customer service and a streamlined online ordering experience.',
      'Shopping is simple: browse the live menu, add your favorites to the cart, choose pickup or delivery, upload your ID, and check out with a $40 minimum. Whether you are in Penn Quarter, Capitol Hill, Shaw, Dupont Circle, or anywhere else in the District, Majestic Greens DMV is built to be the easiest way to order premium cannabis in Washington, DC.',
    ],
    landmarks: 'the National Mall, Penn Quarter, and downtown Washington DC',
    faq: [
      { q: 'Where is Majestic Greens DMV located?', a: 'We are located at 425 7th St NW, Washington, DC 20004, in the Penn Quarter neighborhood of downtown DC.' },
      { q: 'What is the minimum order in Washington DC?', a: 'Our minimum order is $40 across the District, for pickup and delivery.' },
      { q: 'How does online ordering work?', a: 'Browse the live menu, add items to your cart, choose pickup or delivery, upload your ID, and check out. Our team verifies your order before fulfillment.' },
      { q: 'Who can order from Majestic Greens DMV?', a: 'Adults 21 years of age and older with valid ID.' },
    ],
  },
  {
    slug: 'cannabis-delivery-washington-dc',
    name: 'Cannabis Delivery DC',
    title: 'Cannabis Delivery in Washington, DC | Majestic Greens DMV',
    meta: 'Cannabis delivery in Washington DC made easy — order premium flower, vapes, edibles and concentrates online from Majestic Greens DMV. $40 minimum. Adults 21+.',
    h1: 'Cannabis Delivery in Washington, DC',
    intro: [
      'Looking for cannabis delivery in Washington, DC? Majestic Greens DMV makes it simple. Our downtown DC shop at 425 7th St NW serves the entire District with a premium menu and an online ordering experience designed to get you from browsing to checkout in under two minutes.',
      'Every order over $40 is verified with a quick ID upload and delivered by our local team. Enter your ZIP code to confirm we service your address, then shop exotic flower, vape cartridges, edibles, pre-rolls, and concentrates — all from one place.',
    ],
    landmarks: 'downtown DC, the National Mall, and neighborhoods across the District',
    faq: [
      { q: 'Do you offer cannabis delivery in Washington DC?', a: 'Yes — we deliver across the District of Columbia. Confirm your address with our service area checker.' },
      { q: 'Is there a delivery minimum?', a: 'Yes, the minimum order is $40.' },
      { q: 'What areas do you serve?', a: 'We deliver across all of Washington DC, plus parts of Maryland and Virginia — call (202) 320-7287 to confirm addresses outside DC.' },
    ],
  },
];

export const MDVA_AREAS = [
  { name: 'Bethesda', state: 'MD' },
  { name: 'Silver Spring', state: 'MD' },
  { name: 'Takoma Park', state: 'MD' },
  { name: 'Rockville', state: 'MD' },
  { name: 'College Park', state: 'MD' },
  { name: 'Hyattsville', state: 'MD' },
  { name: 'Greenbelt', state: 'MD' },
  { name: 'Laurel', state: 'MD' },
  { name: 'Arlington', state: 'VA' },
  { name: 'Alexandria', state: 'VA' },
];
